import React, { useState, useEffect, useRef } from 'react';
import classnames from 'classnames';
import {Conditional} from 'common/components/layout';
import styles from './CopyLink.scss';
import CopyIcon from './CopyIcon';

export function CopyLink({type, id, useBinderV4}) {
   
    const [showCopySuccess, setShowCopySuccess] = useState(false);
    const dataRef = useRef(null);

    const getURL = () => {
        const origin = window.location.origin;        
        return origin.concat(`/${type}/${id}`);      
    };

    useEffect(() => {
        if (!showCopySuccess) return;

        const timer = setTimeout(() => setShowCopySuccess(false), 3000);
        return () => clearTimeout(timer);
    }, [showCopySuccess]);

    const copyToClipboard = (e) => {
        dataRef.current.select();
        document.execCommand('copy');
        if(useBinderV4) return;
        e.target.focus();
        setShowCopySuccess(true);
    };

    return (
        <div className={classnames(
            styles.dataSection,
            {
                [styles.defaultMarginBottom]: type === 'study' 
            })}
        data-cy="CopyLink"
        >
            <Conditional condition={showCopySuccess}>
                <div className={styles.successMessage}>Copied</div>
            </Conditional>
            <span className={type === 'binder' ? styles.valueBinder : styles.valueStudy}>
                {getURL()}
            </span>
            <span className={styles.verticalDivider}>|</span>
            <span className={type === 'binder' ? styles.valueHoverBinder : styles.valueHoverStudy}
                onClick={copyToClipboard} data-cy="CopyLink-copyToClipboard">
                {
                    useBinderV4 ?  <CopyIcon /> : 'Copy URL'
                }
            </span>
            <input
                className={styles.hidden}
                ref={dataRef}
                defaultValue={getURL()}
                data-cy="CopyLink-input">
            </input>
        </div>
    );
}

export default CopyLink;
